import React from 'react';
import { PinInput, Stack, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import codeSanitize, { AUTH_CODE_LENGTH } from '@/function/auth/code.sanitize';

type Props = {
    label: string;
    value: string;
    error: string | null;
    disabled?: boolean;
    onChange: (value: string) => void;
    onComplete?: (value: string) => void;
};

const FlowCodeField: React.FC<Props> = ({ label, value, error, disabled, onChange, onComplete }) => {
    const labelId = React.useId();
    const roomy = useMediaQuery('(min-width: 30em)');
    return (
        <Stack gap={6} align="center" role="group" aria-labelledby={labelId}>
            <Text id={labelId} size="sm" fw={500}>{label}</Text>
            <PinInput
                length={AUTH_CODE_LENGTH}
                size={roomy ? 'lg' : 'md'}
                radius="md"
                type="number"
                inputMode="numeric"
                oneTimeCode
                placeholder="·"
                value={value}
                error={Boolean(error)}
                disabled={disabled}
                onChange={(next) => onChange(codeSanitize(next))}
                onComplete={onComplete ? (code) => onComplete(codeSanitize(code)) : undefined}
            />
            {error ? <Text c="red" size="sm" ta="center" role="alert">{error}</Text> : null}
        </Stack>
    );
};

export default FlowCodeField;
